/* Euro Fiber OP — confort de lecture : description de collection repliable */
(function () {
  function init() {
    if (!/\/collections\/[^/]+/.test(location.pathname)) return;
    var sec = document.querySelector('main .shopify-section');
    if (!sec) return;
    var rte = sec.querySelector('rte-formatter');
    if (!rte || rte.scrollHeight < 260 || rte.dataset.efoClamp) return;
    rte.dataset.efoClamp = '1';
    rte.classList.add('efo-clamp');
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'efo-more';
    b.textContent = 'Lire la suite';
    b.setAttribute('aria-expanded', 'false');
    b.addEventListener('click', function () {
      var open = rte.classList.toggle('efo-clamp--open');
      b.textContent = open ? 'Réduire' : 'Lire la suite';
      b.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    rte.insertAdjacentElement('afterend', b);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
